import { render, staticRenderFns } from "./ServerFile.vue?vue&type=template&id=6bcfe57c&scoped=true"
import script from "./ServerFile.vue?vue&type=script&lang=js"
export * from "./ServerFile.vue?vue&type=script&lang=js"
import style0 from "./ServerFile.vue?vue&type=style&index=0&id=6bcfe57c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcfe57c",
  null
  
)

export default component.exports